













































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import ConfirmationDialog from '@/components/molecules/ConfirmationDialog.vue';
import EditableList from '@/components/molecules/EditableList.vue';
import FormDialog from '@/components/molecules/FormDialog.vue';
import { BusEventTargets } from '@/containers/globals/BusEvent';
import { i18n } from '@/plugins/i18n/i18n';
import {
  ID,
  ProductMenu,
  EditActionEvent,
  SaveEvent,
  CloseEvent,
} from '@/types/type';

@Component({
  components: {
    ConfirmationDialog,
    FormDialog,
    EditableList,
  },
})
export default class PortalFavoriteMenusDialog extends Vue {
  private titleHideFavorite = i18n.tc('portal.titleHideFavorite');
  private titleHideFavoriteSub1 = i18n.tc('portal.titleHideFavoriteSub1');
  private titleHideFavoriteSub2 = i18n.tc('portal.titleHideFavoriteSub2');
  private titleUpdateFavorite = i18n.tc('portal.titleUpdateFavorite');
  private btnOK = i18n.tc('common.ok');
  private btnCancel = i18n.tc('common.cancel');
  private btnSave = i18n.tc('common.save');

  private confirmHideEvent = BusEventTargets.CONFIRM_DIALOG_FAVORITE;
  private sortMenuEvent = BusEventTargets.FORM_DIALOG_FAVORITE;

  @Prop()
  private menus!: ProductMenu[];

  @Emit('disable-favorite')
  private disableFavorite(): void {}

  @Emit('sort-action')
  private sortAction(event: EditActionEvent): EditActionEvent {
    return { ...event, change: true };
  }

  @Emit('change-favorite-menus')
  private saveFavoriteMenus(): void {
    this.saveCloseAction();
  }

  @Emit('change')
  private saveCloseAction(): SaveEvent {
    return { change: false };
  }
}
